export function isBool(value: any): value is boolean {
  return typeof value === 'boolean';
}
